import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pageTitle: {
    defaultMessage: 'Fulfillment Providers',
    id: 'Ei1QiN',
    description: 'Fulfillment Providers page title',
  },
  pageDescription: {
    defaultMessage: 'Connect and manage your fulfillment providers so you can send your orders to them directly from ShipStation.',
    id: 'x7gNu7',
    description: 'Fulfillment Providers Page Description',
  },
  tooltipContent: {
    defaultMessage: 'A fulfillment provider is a third-party service that packs and ships your orders for you.',
    id: 'Tgyirp',
    description:
      'Fulfillment Providers Page Banner Button - "third-party" in this context means a separate, non-ShipStation-related entity',
  },
  vendorConnectPageDescription: {
    defaultMessage:
      'Connect and manage your fulfillment providers here. Then you can send your orders to them directly from ShipStation. <a>Learn more about fulfillment providers</a>.',
    id: 'FGniFx',
    description: 'Fulfillment Providers Page Description',
  },
  vendorsTabTitle: {
    defaultMessage: 'Vendors',
    id: 'yO7QWL',
    description: 'Tab Title to switch to vendor view.',
  },
  fulfillmentServicesTabTitle: {
    defaultMessage: 'Fulfillment Services',
    id: 'oCOGea',
    description: 'Tab Title to switch to Fulfillment Services view.',
  },
  carrierSharingCountersLoadError: {
    description: 'Content for Error Pop Up when carrier sharing data failed to load.',
    defaultMessage: 'An unexpected error occurred while loading carrier sharing data for vendors.',
    id: 'Uri6DO',
  },
  carrierSharingValidationErrorBack: {
    description: 'Carrier sharing validation error back button text',
    defaultMessage: 'Back',
    id: 'jttOkm',
  },
  carrierSharingValidationErrorTitle: {
    description: 'Carrier sharing validation error modal title',
    defaultMessage: 'Shared Services Validation Error',
    id: 'Npd8fp',
  },
  carrierSharingValidationErrorMessage: {
    description: 'Carrier sharing validation error modal message',
    defaultMessage: 'ShipStation cannot share services from multiple accounts. Please select the shared services from a single account.',
    id: '9DvGbC',
  },
});

export default messages;
